import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_3 = { class: "kn-truncated" }
const _hoisted_4 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "kn-truncated" }
const _hoisted_7 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-mt-3" }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.layerFilters')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "p-button-link",
              label: _ctx.$t('workspace.gis.dnl.addFilters'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driverDialogVisible = true))
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          class: "georef-step1-table p-datatable-sm kn-table",
          value: _ctx.documentData.selectedDriver,
          dataKey: "id",
          responsiveLayout: "scroll",
          breakpoint: "600px",
          filters: _ctx.mainFilters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.mainFilters = $event)),
          globalFilterFields: _ctx.globalFilterFields
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.driversTableEmpty')), 1)
          ]),
          header: _withCtx(() => [
            _createVNode("span", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.mainFilters['global'].value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.mainFilters['global'].value = $event)),
                placeholder: _ctx.$t('common.search')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                field: col.field,
                header: _ctx.$t(col.header),
                key: col.field,
                sortable: true
              }, {
                body: _withCtx(({data}) => [
                  _withDirectives(_createVNode("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(data[col.field]), 1)
                  ], 512), [
                    [
                      _directive_tooltip,
                      data[col.field],
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                _: 2
              }, 1032, ["field", "header"]))
            }), 128)),
            (!_ctx.isDatasetChosen)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  style: _ctx.styleDescriptor.style.trashColumn,
                  onRowClick: false
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Button, {
                      icon: "pi pi-trash",
                      class: "p-button-link",
                      onClick: ($event: any) => (_ctx.deleteselectedDriver(slotProps))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value", "filters", "globalFilterFields"])
      ]),
      _: 1
    }),
    (_ctx.driverDialogVisible)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          class: "p-fluid kn-dialog--toolbar--primary",
          style: _ctx.styleDescriptor.style.dialogSize,
          visible: _ctx.driverDialogVisible,
          modal: true,
          closable: false
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.layerList')), 1)
              ]),
              _: 1
            })
          ]),
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                class: "kn-button kn-button--secondary",
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "kn-button kn-button--primary",
                onClick: _ctx.saveLayerSelection
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm kn-table",
              value: _ctx.documentData.allDrivers,
              selection: _ctx.selectedDriversList,
              "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedDriversList = $event)),
              dataKey: "id",
              responsiveLayout: "scroll",
              filters: _ctx.multipleFilters,
              "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => (_ctx.multipleFilters = $event)),
              globalFilterFields: _ctx.globalFilterFields
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.layersDialogEmpty')), 1)
              ]),
              header: _withCtx(() => [
                _createVNode("span", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    modelValue: _ctx.multipleFilters['global'].value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.multipleFilters['global'].value = $event)),
                    placeholder: _ctx.$t('common.search')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, { selectionMode: "multiple" }),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    field: col.field,
                    header: _ctx.$t(col.header),
                    key: col.field
                  }, {
                    body: _withCtx(({data}) => [
                      _withDirectives(_createVNode("span", _hoisted_6, [
                        _createTextVNode(_toDisplayString(data[col.field]), 1)
                      ], 512), [
                        [
                          _directive_tooltip,
                          data[col.field],
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["field", "header"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "selection", "filters", "globalFilterFields"])
          ]),
          _: 1
        }, 8, ["style", "visible"]))
      : _createCommentVNode("", true)
  ], 64))
}